var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLogoFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 72,
  height: 56,
  viewBox: "0 0 72 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M71.3522 0H0V55.0342H71.3522V0Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.585 48.8717V6.15625L6.15691 6.15625L6.15691 48.8717H32.585Z",
  fill: "#FFCB05"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M65.2004 48.8717V6.15625L38.7724 6.15625V48.8717H65.2004Z",
  fill: "#001246"
})));
export default SvgIconLogoFlag;